import { deviceBrowserName, getNetworkInfo, isImageGif } from '../utils';
import { encodeId } from '../utils/encryption';
import { APP_VIEW, PLAYER_STATES, SLIKE_GA_ID, GO_LIVE_STATES, EVENT_TYPE, APP_EVENTS } from '../constants';

class GAPlugin {
  constructor(ctrl, store) {
    this.ctrl = ctrl;
    this.store = store;
    this.gaIds = [];
    var { gaId } = this.store.getState().app.config;

    if (gaId) {
      this.gaIds = gaId.split(',');
    }
    if (this.gaIds.indexOf(SLIKE_GA_ID) === -1) {
      this.gaIds.push(SLIKE_GA_ID);
    }
    var apiKeyJson = this.store.getState().app.apiKeyJson;
    if (apiKeyJson && apiKeyJson?.conf.analytics) {
      var apiJsonGaIds = apiKeyJson.conf.analytics.ga;
      apiJsonGaIds &&
        apiJsonGaIds.forEach((ga) => {
          if (ga.platforms.includes('web') && this.gaIds.indexOf(ga.id) === -1) {
            this.gaIds.push(ga.id);
          }
        });
    }

    this.portal = '';

    if (this.gaIds.length > 0) {
      this.portal = 'ga';
      for (var i = 0; i < this.gaIds.length; i++) {
        window.ga('create', this.gaIds[i], 'auto', { name: `account${i}`, cookieFlags: 'SameSite=None; Secure' });
      }
    } else {
      this.portal = 'firebase';
      this.firebaseConfig();
    }
    this.gaPrefix_eventCategory = this.store.getState().app.config.gaPrefix;
    this.gaPrefix = '';
    this.UID = `${this.gaPrefix}${this.store.getState().app.config.jwtData.userID}`;
    if (apiKeyJson?.conf?.analytics?.ga[0]?.encoding) {
      this.UID = encodeId(this.UID);
    }
    this.event_id = `${this.gaPrefix}${this.store.getState().app.config.jwtData.eventID}`;
    this.user_type = `${this.gaPrefix}${this.store.getState().app.limitedViewing ? 'free' : 'paid'}`;
    this.location = null;
    this.IP = null;
    this.browser = `${this.gaPrefix}${deviceBrowserName()}`;
    this.prevGoLive = GO_LIVE_STATES.NEVER_LIVE;
  }

  firebaseConfig(config) {
    var firebaseConfig = {
      apiKey: 'AIzaSyBcVe2qb91lMCs0JLlYFFKCVfYp5GjuGMs',
      authDomain: 'slike-business.firebaseapp.com',
      databaseURL: 'https://slike-business.firebaseio.com',
      projectId: 'slike-business',
      storageBucket: 'slike-business.appspot.com',
      messagingSenderId: '1061636414490',
      appId: '1:1061636414490:web:196ed1868b5c5047c545a3',
      measurementId: 'G-QF6DWWX8LG',
    };
    // Initialize Firebase
    window.firebase.initializeApp(firebaseConfig);
    window.analytics = window.firebase.analytics();
  }

  trigger(action) {
    try {
      const type = action.type.replace('app/', '');
      const method = `on${type.substring(0, 1).toUpperCase()}${type.substring(1)}`;
      if (typeof this[method] === 'function') {
        this[method](action);
      }
    } catch (err) {
      console.error('Error in GA Trigger', action.type, err);
    }
    // console.log("GA Trigger", method);
  }
  getAction() {
    return '';
  }
  getLabel() {
    return '';
  }
  sendGA(eventCategory, eventAction, parameter = '') {
    if (this.portal === 'ga') {
      for (var i = 0; i < this.gaIds.length; i++) {
        window.ga(`account${i}.send`, {
          hitType: 'event',
          eventCategory: this.gaPrefix_eventCategory + eventCategory,
          eventAction: eventAction,
          eventLabel: `action=${eventAction},${parameter.toLowerCase().replaceAll(' ', '_')}`,
        });
      }
    } else if (this.portal === 'firebase') {
      window.analytics.logEvent(eventCategory, {
        hitType: 'event',
        eventCategory: this.gaPrefix_eventCategory + eventCategory,
        eventAction: eventAction,
        eventLabel: parameter.toLowerCase().replaceAll(' ', '_'),
      });
    }
    const payload = { eventCategory: eventCategory, eventAction: eventAction, parameter: parameter };
    this.ctrl.emit(APP_EVENTS.GA_EVENT, payload);
  }

  onSetAppConfig(action) {
    let client_Name = `${this.gaPrefix}${action.payload.config.jwtData.provider}`;
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=null,screen_name=${client_Name},geo_location=${this.location}`;
    this.sendGA('sdk_launch', 'init', parameter.toLowerCase());
  }
  onSetAppView() {
    let screen_name = this.store.getState().app.view;
    let event_type = this.store.getState().app.eventType;
    let event_type1 = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    for (var key in APP_VIEW) {
      if (APP_VIEW[key] === screen_name) {
        screen_name = key;
        break;
      }
    }
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type1},screen_name=${this.gaPrefix}${screen_name}`;
    if (screen_name) {
      this.sendGA('screen_open', screen_name.toLowerCase(), parameter);
    }
    if (screen_name === 4 && event_type === 3) {
      let bit_rate = `${this.gaPrefix}${this.store.getState().app.bitRate}`;
      let error_name = null;
      let retry_count = `${this.gaPrefix}0`;
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
        this.browser
      },video_type=${event_type1},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
        getNetworkInfo().effectiveType
      },bitrate=${bit_rate},stream_id=${this.event_id},error_name=${error_name},retry_count=${retry_count}`;
      this.sendGA('stream', 'recorded_play', parameter);
    }
  }

  onProceedClick(action) {
    let name = this.store.getState().app.apiJsonConfig.skipForm ? 'without_name' : 'with_name';
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},name=${this.gaPrefix}${name}`;
    this.sendGA('enter_live', 'live_enter', parameter);
    if (action.payload.bForce) {
      this.sendGA(
        'click',
        'force_login',
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${this.event_type},msg_text=null,chat_reaction=null,Social_media=null`,
      );
    }
  }

  onSetShareBox(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    if (action.payload) {
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},screen_name=${this.gaPrefix}share_screen`;
      this.sendGA('screen_open', 'share_screen', parameter);
    } else {
      let screen_name = this.store.getState().app.view;
      for (var key in APP_VIEW) {
        if (APP_VIEW[key] === screen_name) {
          screen_name = key;
          break;
        }
      }
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},screen_name=${this.gaPrefix}${screen_name}`;
      this.sendGA('screen_open', screen_name.toLowerCase(), parameter);
    }
  }

  onSetBitRate(action) {
    let error_name = null;
    let retry_count = `${this.gaPrefix}0`;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
      this.browser
    },video_type=${event_type},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
      getNetworkInfo().effectiveType
    },bitrate=${this.gaPrefix}${action.payload},stream_id=null,error_name=${error_name},retry_count=${retry_count}`;
    this.sendGA('stream', 'bitrate_change', parameter);
  }

  onStreamChange(action) {
    let error_name = null;
    let bit_rate = `${this.gaPrefix}${this.store.getState().app.bitRate}`;
    let retry_count = `${this.gaPrefix}0`;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
      this.browser
    },video_type=${event_type},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
      getNetworkInfo().effectiveType
    },bitrate=${bit_rate},stream_id=${action.payload},error_name=${error_name},retry_count=${retry_count}`;
    this.sendGA('stream', 'fallback', parameter);
  }

  onSetPlayerState(action) {
    let error_name = null;
    let bit_rate = `${this.gaPrefix}${this.store.getState().app.bitRate}`;
    let retry_count = `${this.gaPrefix}0`;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    var state;
    for (var key in PLAYER_STATES) {
      if (PLAYER_STATES[key] === action.payload) {
        state = key;
        break;
      }
    }
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
      this.browser
    },video_type=${event_type},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
      getNetworkInfo().effectiveType
    },bitrate=${bit_rate},stream_id=null,error_name=${error_name},retry_count=${retry_count}`;
    if (state) {
      this.sendGA('stream', state.toLowerCase(), parameter);
    }
  }

  onSetPlayerStateResume() {
    let error_name = null;
    let bit_rate = `${this.gaPrefix}${this.store.getState().app.bitRate}`;
    let retry_count = `${this.gaPrefix}0`;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
      this.browser
    },video_type=${event_type},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
      getNetworkInfo().effectiveType
    },bitrate=${bit_rate},stream_id=null,error_name=${error_name},retry_count=${retry_count}`;
    this.sendGA('stream', 'resumed', parameter);
  }

  onStreamHalted() {
    let error_name = null;
    let bit_rate = `${this.gaPrefix}${this.store.getState().app.bitRate}`;
    let retry_count = `${this.gaPrefix}0`;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
      this.browser
    },video_type=${event_type},IP_address=${this.IP},user_bandwidth=${this.gaPrefix}${
      getNetworkInfo().effectiveType
    },bitrate=${bit_rate},stream_id=null,error_name=${error_name},retry_count=${retry_count}`;
    this.sendGA('stream', 'halted', parameter);
  }

  onChangeBanner(action) {
    var { aston_id, type, url } = action.payload;
    type = type === 'Image' && isImageGif(url) ? 'gif' : type;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    if (action.payload.action === 1) {
      let duration = `${this.gaPrefix}${action.payload.duration}`;
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},aston_id=${aston_id},duration_displayed=${duration},user_closed=null,aston_type=${type}`;
      this.sendGA('aston', 'displayed', parameter);
    } else if (action.payload.action === 0) {
      let duration = `${this.gaPrefix}${action.payload.time}`;
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},aston_id=${aston_id},duration_displayed=${duration},user_closed=${this.gaPrefix}admin_closed,aston_type=${type}`;
      this.sendGA('aston', 'closed', parameter);
    } else if (action.payload.action === 2) {
      let duration = `${this.gaPrefix}${action.payload.time}`;
      let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},aston_id=${aston_id},duration_displayed=${duration},user_closed=${this.gaPrefix}auto_closed,aston_type=${type}`;
      this.sendGA('aston', 'closed', parameter);
    }
  }
  onSetUserBlocked() {
    this.sendGA(
      'user_blocked',
      'blocked',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=null,geo_location=${this.location},IP_address=${this.IP}`,
    );
  }
  onSetLimitedSessionStart() {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'limited_view',
      'start',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},geo_location=${this.location}`,
    );
  }
  onSetSessionExpired() {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'limited_view',
      'end',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},geo_location=${this.location}`,
    );
    let parameter = `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},screen_name=${this.gaPrefix}share_screen`;
    this.sendGA('screen_open', 'paywall_url_open', parameter);
  }
  onSetAppError(action) {
    if (action.payload.act) {
      let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
      let bit_rate = this.store.getState().app.bitRate;
      this.sendGA(
        'error',
        action.payload.act,
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
          this.browser
        },video_type=${event_type},error_type=${this.gaPrefix}${action.payload.act},bitrate=${
          this.gaPrefix
        }${bit_rate},user_bandwidth=${this.gaPrefix}${getNetworkInfo().effectiveType}`,
      );
    }
  }
  onSetNetworkError(action) {
    if (action.payload) {
      let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
      let bit_rate = this.store.getState().app.bit_rate;
      this.sendGA(
        'error',
        'network',
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
          this.browser
        },video_type=${event_type},error_type=${this.gaPrefix}'network',bitrate=${
          this.gaPrefix
        }${bit_rate},user_bandwidth=${this.gaPrefix}${getNetworkInfo().effectiveType}`,
      );
    }
  }
  onSetPlayerError(action) {
    if (!action.payload) {
      let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
      let bit_rate = this.store.getState().app.bitRate;
      this.sendGA(
        'error',
        'network',
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
          this.browser
        },video_type=${event_type},error_type=${this.gaPrefix}'network',bitrate=${
          this.gaPrefix
        }${bit_rate},user_bandwidth=${this.gaPrefix}${getNetworkInfo().effectiveType}`,
      );
    }
  }
  onSetScreenShotConfig(action) {
    if (!action.payload) {
      let bit_rate = this.store.getState().app.bitRate;
      let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
      this.sendGA(
        'error',
        'screenshot',
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
          this.browser
        },video_type=${event_type},error_type=${this.gaPrefix}'screenshot',bitrate=${
          this.gaPrefix
        }${bit_rate},user_bandwidth=${this.gaPrefix}${getNetworkInfo().effectiveType}`,
      );
    }
  }
  onSetCountDown(action) {
    const act = action.payload ? '_start' : '_ended';
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'countdown',
      act,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type}`,
    );
  }
  onSetSSDeleteAll(action) {
    const act = action.payload ? 'screenshot_delete_all' : 'screenshot_delete';
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      act,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=null`,
    );
  }
  onSetSSDownloadAll(action) {
    const act = action.payload ? 'download_all' : 'download';
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      act,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=null`,
    );
  }
  onSendReaction(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'chat_reactions',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=${this.gaPrefix}${action.payload},Social_media=null`,
    );
  }
  onSendQnaMessage(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'sent_qna',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},qna_text=${this.gaPrefix}${action.payload},chat_reaction=null,Social_media=null`,
    );
  }
  onSendChatMessage(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'sent_chat',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg_text=${this.gaPrefix}${action.payload},chat_reaction=null,Social_media=null`,
    );
  }
  onSetSharePortal(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'share_social',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=${this.gaPrefix}${action.payload}`,
    );
  }
  onToggleFullScreen(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    const act = action.payload ? 'fullscreen' : 'exit_fullscreen';
    this.sendGA(
      'click',
      act,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=null`,
    );
  }
  onTakeScreenshotClick() {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'screenshot',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=null`,
    );
  }
  onPayWallClick(action) {
    const duration = action.payload;
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    this.sendGA(
      'click',
      'paywall_button',
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},msg/qna_text=null,chat_reaction=null,Social_media=null,duration=${duration}`,
    );
  }
  onSetGoLive(action) {
    var gaAction =
      action.payload === GO_LIVE_STATES.NEVER_LIVE
        ? 'never'
        : action.payload === GO_LIVE_STATES.STARTED
        ? 'start'
        : action.payload === GO_LIVE_STATES.PAUSED
        ? 'pause'
        : action.payload === GO_LIVE_STATES.ENDED
        ? 'ended'
        : '';
    if (this.prevGoLive !== GO_LIVE_STATES.NEVER_LIVE && action.payload === GO_LIVE_STATES.STARTED) {
      gaAction = 'resumed';
    }
    this.sendGA(
      'event',
      gaAction,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${
        this.browser
      },video_type=${null},msg/qna_text=null,chat_reaction=null,Social_media=null`,
    );
    this.prevGoLive = action.payload;
  }

  onSetMomentGA(action) {
    let event_type = this.store.getState().app.eventType === EVENT_TYPE.HLS_LIVE ? 'live' : 'vod';
    if (action.payload.action === 'error') {
      this.sendGA(
        'error',
        'capture_error',
        `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},type=${action.payload.momentType}`,
      );
      return;
    }
    this.sendGA(
      'moments',
      action.payload.action,
      `event_id=${this.event_id},UID=${this.UID},user_type=${this.user_type},platform=${this.browser},video_type=${event_type},type=${action.payload.momentType}`,
    );
  }
}

let gaPlugin;

export const gaAnalytics = (ctrl) => (store) => (next) => (action) => {
  next(action);
  if (!store.getState().app.config.castMode) {
    if (typeof window.ga !== 'undefined') {
      try {
        if (!gaPlugin) {
          gaPlugin = new GAPlugin(ctrl, store);
        }
        if (gaPlugin) {
          gaPlugin.trigger(action);
        }
      } catch (err) {
        console.error('GAPlugin', err);
      }
    }
  }
};
